module.exports = __webpack_public_path__ + "img/triangle_4.677b0171.png";